import { configureStore } from '@reduxjs/toolkit';
import RootReducer from './slices';
import storage from 'redux-persist/lib/storage';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const migrations = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  2: (state: any) => {
    if (!state) return state;
    return {
      ...state,
      cart: {
        ...(state.cart ?? {}),
        syncedBaseline: state.cart?.syncedBaseline ?? {},
        isLoading: false,
      },
      payment: {
        ...(state.payment ?? {}),
        isFetching: false,
      },
    };
  },
};

const persistedConfig = {
  key: 'root',
  version: 2,
  storage,
  whitelist: ['auth', 'cart', 'user', 'search', 'order'],
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistedConfig, RootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);
